import { Button, Card, Col, Flex, Image, Row } from "antd";
import { Control, FieldErrors } from "react-hook-form";
import { InputField, SelectField } from "../../../../../atoms/FormFields";
import { TimePickerField } from "../../../../../atoms/FormFields/TimePickerField";
import { useState } from "react";
import { MapIcon } from "../../../../../atoms/CustomIcons";

const CustomAddress = ({
  control,
  errors,
}: {
  control: Control;
  errors: FieldErrors;
}) => {
  const [showMapImage, setShowMapImage] = useState(false);
  return (
    <Card className="custom-address-card">
      <Flex
        justify="space-between"
        align="center"
        style={{ marginBottom: "12px" }}
      >
        <h5>Custom Address</h5>
        <Button
          className={
            showMapImage ? "btn-sm primary-btn" : "btn-sm outlined-btn"
          }
          type={showMapImage ? "primary" : "default"}
          onClick={() => setShowMapImage(!showMapImage)}
        >
          <MapIcon style={{ color: showMapImage ? "white" : "#151718" }} /> Set
          on map
        </Button>
      </Flex>
      <Row gutter={16}>
        {showMapImage && (
          <Col span={24}>
            <Image
              src="/images/schedule/map-placeholder.png"
              alt="Map Placeholder"
              preview={false}
              style={{ marginBottom: 6 }}
            />
          </Col>
        )}
        <Col span={15}>
          <InputField
            fieldName="name"
            label="Location name"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Enter location name",
            }}
            isRequired
            rules={{
              required: "Location name is required.",
            }}
            validate={errors.name && "error"}
            validMessage={
              typeof errors.name?.message === "string"
                ? errors.name.message
                : undefined
            }
          />
        </Col>
        <Col span={9}>
          <TimePickerField
            fieldName="allocatedTime"
            label="Allocated time"
            control={control}
            isRequired
            rules={{
              required: "Allocated time is required.",
            }}
            validate={errors.allocatedTime && "error"}
            validMessage={
              typeof errors.allocatedTime?.message === "string"
                ? errors.allocatedTime.message
                : undefined
            }
            tooltipTitle="Allocated Time"
          />
        </Col>

        <Col span={24}>
          <InputField
            fieldName="streetAddress"
            label="Street address"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Search street address",
            }}
            isRequired
            rules={{
              required: "Street address is required.",
            }}
            validate={errors.streetAddress && "error"}
            validMessage={
              typeof errors.streetAddress?.message === "string"
                ? errors.streetAddress.message
                : undefined
            }
          />
        </Col>
        <Col span={24}>
          <Row gutter={8}>
            <Col span={10} className="mb-0">
              <InputField
                fieldName="city"
                label="City"
                control={control}
                defaultValue=""
                iProps={{
                  placeholder: "City",
                }}
              />
            </Col>
            <Col span={7} className="mb-0">
              <SelectField
                fieldName="state"
                label="State"
                control={control}
                selectOption={[]}
                iProps={{
                  placeholder: "State",
                }}
              />
            </Col>
            <Col span={7} className="mb-0">
              <InputField
                fieldName="zip"
                label="ZIP"
                control={control}
                defaultValue=""
                iProps={{
                  placeholder: "ZIP",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default CustomAddress;
